import { FC, ReactNode, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useRouter } from "@tanstack/react-router";
export interface SentryTanstackRouterIntegrationProps {
  children: ReactNode;
}

export const SentryTanstackRouterIntegration: FC<
  SentryTanstackRouterIntegrationProps
> = (props) => {
  const router = useRouter();

  useEffect(() => {
    console.log("SentryTanstackRouterIntegration: adding integration");
    Sentry.addIntegration(
      Sentry.tanstackRouterBrowserTracingIntegration(router)
    );
  }, [router]);

  return props.children;
};
